import React, { useState, useRef, useEffect } from 'react';

export default function Accordion({ title, children }) {
  const [open, setOpen] = useState(false);
  const content = useRef(null);
  const [height, setHeight] = useState('0px');

  useEffect(() => {
    setHeight(open ? `${content.current.scrollHeight}px` : '0px');
  }, [open]);

  return (
    <div className="accordion-section">
      <div className="accordion-toggle" onClick={() => setOpen(!open)}>
        {title}
      </div>
      <div ref={content} style={{ maxHeight: height, overflow: 'hidden', transition: 'max-height 0.3s ease' }}>
        <div className="accordion-content">
          {children}
        </div>
      </div>
    </div>
  );
}
